export default class Project {
  name;
  description;
  link;
  startDate;
  endDate;
  present = false;
  constructor(data) {
    this.name = data?.name;
    this.description = data?.description;
    this.link = data?.link;
    this.startDate = data?.startDate;
    this.endDate = data?.endDate;
    this.present = data?.present;
  }
}
